import React from "react"
import PatientDetailComponent from "../components/PatientDetails/PatientDetail"

const PatientDetailView = () => <PatientDetailComponent />

export default PatientDetailView
